export const SET_USER_DATA = 'SAVE_USER_DATA';
export const SET_USER_AUTH = 'SAVE_USER_AUTH';
export const SET_USER_TOKEN = 'SAVE_USER_TOKEN';
export const SET_USER_ACTIVE = 'SAVE_USER_ACTIVE';
export const SET_USER_DEBTS = 'SAVE_USER_DEBTS';
